import { Grid, styled } from "@mui/material";

export const Container = styled(Grid)({
  margin: "95px auto 0",
  maxWidth: "1366px",
});
